import { Injectable } from '@angular/core';
import { BaseReportService } from '@app/api/api-services/base-report.service';
import { QuizzesReportRequestApiModel, QuizzesReportApiModel, QuizzesReportFiltersApiModel } from '@app/api/api-models';

@Injectable()
export class QuizzesReportService extends BaseReportService<
  QuizzesReportFiltersApiModel,
  QuizzesReportRequestApiModel,
  QuizzesReportApiModel
> {
  public readonly apiUrl = 'reports/quizzes';
}
